export let OwnerFilterOption;
(function (OwnerFilterOption) {
  OwnerFilterOption["ALL"] = "ALL";
  OwnerFilterOption["UNASSIGNED"] = "UNASSIGNED";
  OwnerFilterOption["ME"] = "ME";
})(OwnerFilterOption || (OwnerFilterOption = {}));